import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';

type SettingPatternValidationTypes = '$min' | '$max';

@Injectable({
    providedIn: 'root'
})
export class SettingValidators
{
    /**
     * Setting validation to make sure $min and $max is being used for pattern settings
     *
     * @param aType Setting pattern validation type
     * @returns null if validation succeed or JSON object when validation failed.
     */
    public validateRegExMinMax(aType: SettingPatternValidationTypes): ValidatorFn
    {
        return (control: AbstractControl): { [key: string]: any } | null =>
        {
            if ((control.value !== null) && (control.value.length > 0) && (control.value.substring(0, 1) !== '/'))
            {
                if (aType === '$min')
                {
                    return (control.value.indexOf(aType) < 0) ? { missingMin: true } : null;
                }
                else if (aType === '$max')
                {
                    return (control.value.indexOf(aType) < 0) ? { missingMax: true } : null;
                }
            }
            return null;
        };
    }
}
